module.exports = __webpack_public_path__ + "static/media/baby-eating.6564801e.jpeg";